import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Badge from '@mui/material/Badge';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, IconButton, Typography } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import { useDispatch, useSelector } from 'react-redux';
import { Close } from '@mui/icons-material';
import { httpRequest } from 'src/services/httpRequest';
import { handleGetNotification } from 'src/utils/sendNotification';
import toast from 'react-hot-toast';
import { getTimeDifference } from 'src/utils/CommonFunctions';

export default function NotificationDrawer({
  showNotifications,
  setShowNotifications,
  handleReadNotification
}) {
  const notificationList = useSelector(
    (state: any) => state.notifications.notifications
  );
  const dispatch = useDispatch();
  const cardDesign = {
    backgroundColor: '#dadde1',
    mb: 1,
    borderRadius: 1,
    minHeight: '50px',
    display: 'block'
  };

  //Method to delete notifications
  const handleDeleteNotifications = async (ID, deleteType = '') => {
    const payload = {
      deleteType,
      ID
    };
    const response = await httpRequest(
      'DELETE',
      '/notification/delete',
      payload
    );
    if (response?.status === 'success') {
      handleGetNotification(dispatch);
    } else {
      toast.error(response?.message);
    }
  };

  const WrappedList = () => {
    return (
      <Box
        role="presentation"
        position={'relative'}
        onClick={() => setShowNotifications(false)}
        onKeyDown={() => setShowNotifications(false)}
      >
        <Divider />
        <List sx={{ pb: 8 }}>
          {notificationList && notificationList?.length ? (
            notificationList?.map((val) => {
              return (
                <ListItem disablePadding key={val?.ID}>
                  <ListItemButton sx={{ px: 1, width: '350px', ...cardDesign }}>
                    <Box
                      display={'flex'}
                      alignItems={'center'}
                      justifyContent={'space-between'}
                      position={'relative'}
                      minHeight={'33px'}
                    >
                      <Box
                        display={'flex'}
                        alignItems={'center'}
                        sx={{ cursor: 'pointer' }}
                        width={'300px'}
                        minHeight={'58px'}
                        onClick={() => handleReadNotification(val, 'Redirect')}
                      >
                        <ListItemIcon sx={{ minWidth: '35px' }}>
                          {!val?.Read ? (
                            <Badge
                              color="error"
                              variant="dot"
                              invisible={false}
                            >
                              <SmsIcon />
                            </Badge>
                          ) : (
                            <SmsIcon />
                          )}
                        </ListItemIcon>
                        <ListItemText>
                          <Box>
                            <Typography
                              sx={{
                                lineHeight: '18px',
                                fontSize: '12px',
                                fontWeight: '600'
                              }}
                            >
                              {val?.PermitName || val?.Title}
                            </Typography>
                            <Typography
                              sx={{ lineHeight: '15px', fontSize: '12px' }}
                              className="add_ellipse_after_2"
                            >
                              {val?.Message}
                            </Typography>
                          </Box>
                        </ListItemText>
                      </Box>
                      <Box>
                        <IconButton
                          sx={{ p: 0 }}
                          onClick={() => handleDeleteNotifications(val?.ID)}
                        >
                          <Close
                            sx={{
                              fontSize: '20px',
                              boxShadow:
                                'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em',
                              backgroundColor: 'white',
                              borderRadius: '50%'
                            }}
                          />
                        </IconButton>
                      </Box>
                      <Box
                        display={'flex'}
                        position={'absolute'}
                        justifyContent={'end'}
                        top={'-5px'}
                        right={'-6px'}
                      >
                        <Typography
                          sx={{ fontSize: '10px', px: '4px', py: '1px' }}
                        >
                          {getTimeDifference(val?.CreateDate)}
                        </Typography>
                      </Box>
                    </Box>
                  </ListItemButton>
                </ListItem>
              );
            })
          ) : (
            <Typography px={5} mt={5}>
              Notifications not found.{' '}
            </Typography>
          )}
        </List>
        {notificationList && notificationList?.length ? (
          <Box
            position={'fixed'}
            bottom={0}
            display={'flex'}
            justifyContent={'center'}
            width={'350px'}
            alignItems={'center'}
            mb={1}
          >
            <Button
              sx={{
                backgroundColor: (theme) => theme.palette.primary.main,
                color: (theme) => theme.palette.secondary.contrastText,
                '&:hover': {
                  backgroundColor: (theme) => theme.palette.primary.dark
                },
                cursor: 'pointer',
                px: 3,
                py: 1,
                boxShadow:
                  'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px'
              }}
              onClick={() => handleDeleteNotifications(null, 'ALL')}
            >
              Clear All
            </Button>
          </Box>
        ) : null}
      </Box>
    );
  };
  return (
    <div>
      <React.Fragment>
        <SwipeableDrawer
          anchor={'right'}
          open={showNotifications}
          onClose={() => setShowNotifications(false)}
          onOpen={() => setShowNotifications(true)}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }} px={1} py={2}>
            <IconButton
              sx={{ p: 0 }}
              onClick={() => setShowNotifications(false)}
            >
              <ChevronRightIcon />
            </IconButton>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              width={'100%'}
            >
              <NotificationsActiveTwoToneIcon sx={{ fontSize: '18px' }} />
              <Typography fontSize={'15px'} ml={0.5} fontWeight={600}>
                Notifications
              </Typography>
            </Box>
          </Box>
          <WrappedList />
        </SwipeableDrawer>
      </React.Fragment>
    </div>
  );
}
